// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { SectionContainer, SectionTitle } from "@guestsupply/App/Widgets/DesignSystem/DesignSystem.helpers";
import { longText } from "@guestsupply/App/Widgets/DesignSystem/DummyData/DummyData";
import StepperContextProvider, { StepperContext } from "@guestsupply/App/Widgets/Stepper/StepperContext";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { createWidgetElement } from "@insite/client-framework/Components/ContentItemStore";
import translate from "@insite/client-framework/Translate";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import AlertTriangle from "@insite/mobius/Icons/AlertTriangle";
import Link from "@insite/mobius/Link";
import Tooltip from "@insite/mobius/Tooltip/Tooltip";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

interface StepperStyles {
    titleGridItem?: GridItemProps;
    gridItem?: GridItemProps;
    tooltipWrapper?: InjectableCss;
}

const tooltipTabStyles: StepperStyles = {
    titleGridItem: {
        width: 12,
    },
    gridItem: {
        width: 12,
        css: css`
            flex-wrap: wrap;
            padding-bottom: 40px;
        `,
    },
    tooltipWrapper: {
        css: css`
            display: flex;
            justify-content: space-between;
            width: 100%;
            margin-top: 20px;
            flex-wrap: wrap;
        `,
    },
};

const styles = tooltipTabStyles;

const StepperTab: FC = props => {
    return (
        <SectionContainer>
            <GridItem {...styles.titleGridItem}>
                <SectionTitle>{translate("Stepper")}</SectionTitle>
            </GridItem>
            <GridItem width={12}>
                <StyledWrapper {...styles.tooltipWrapper}>
                    <StepperContextProvider
                        initialStep={1}
                        allowStepClick={true}
                        steps={[
                            {
                                index: 1,
                                name: "Address",
                                prev: -1,
                                displayName: "Customer & Shipping Address",
                                next: 2,
                            },
                            {
                                index: 2,
                                name: "Shipping",
                                prev: 1,
                                displayName: "Shippings & Carriers",
                            },
                            {
                                index: 3,
                                name: "Payment",
                                prev: 2,
                                displayName: "Payment Information",
                            },
                            {
                                index: 4,
                                name: "Review",
                                prev: 3,
                                displayName: "Review & Confirm Order",
                            },
                        ]}
                    >
                        <StepperContext.Consumer>
                            {({ showStep }) => {
                                return (
                                    <>
                                        {createWidgetElement("Stepper/Stepper", {
                                            fields: {},
                                        })}
                                        <StyledWrapper
                                            css={css`
                                                padding: 16px;
                                            `}
                                        >
                                            {showStep(1) && <StyledWrapper>Step 1</StyledWrapper>}
                                            {showStep(2) && <StyledWrapper>Step 2</StyledWrapper>}
                                            {showStep(3) && <StyledWrapper>Step 3</StyledWrapper>}
                                            {showStep(4) && <StyledWrapper>Step 4</StyledWrapper>}
                                        </StyledWrapper>
                                    </>
                                );
                            }}
                        </StepperContext.Consumer>
                    </StepperContextProvider>
                </StyledWrapper>
            </GridItem>
        </SectionContainer>
    );
};

export default StepperTab;
